import { createContext, type ReactNode, useContext } from 'react';

interface PreviewContextType {
    isPreviewMode: boolean;
}

const PreviewContext = createContext<PreviewContextType | undefined>(undefined);

interface PreviewProviderProps {
    isPreviewMode: boolean;
    children: ReactNode;
}

export function PreviewProvider({ isPreviewMode, children }: PreviewProviderProps) {
    const value: PreviewContextType = {
        isPreviewMode
    };

    return <PreviewContext.Provider value={value}>{children}</PreviewContext.Provider>;
}

export function useIsPreview(): PreviewContextType {
    const context = useContext(PreviewContext);
    if (context === undefined) {
        return { isPreviewMode: false };
    }
    return context;
}

export default PreviewContext;
